import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Grid, Typography, Dialog, DialogTitle, DialogContent, Card, CardContent } from '@mui/material';

import '../homepage/Homepage.css'
import MainImage from '../homepage/images/mainImage.png'
import CtaImage from '../homepage/images/ctaImage.png';
import IntegrationImage from '../homepage/images/integration.jpg';
import FoodCourt from '../homepage/images/foodcourt.png';
import Finedine from '../homepage/images/finedine.png';
import Cafe from '../homepage/images/cafe.png';
import Bar from '../homepage/images/bar.png';
import Pizza from '../homepage/images/pizza.png';
import QRS from '../homepage/images/ORS.png';
import Desserts from '../homepage/images/desserts.png';
import Bakery from '../homepage/images/bakery.png';
import Cloudkitchen from '../homepage/images/cloudkitchen.png';
import Largechain from '../homepage/images/restaurant.png';

import Navbar from '../homepage/components/Navbar';

import Features from '../homepage/components/Features';

import MailIcon from '@mui/icons-material/Mail';
import ContactForm from '../homepage/components/ContactForm';
import Footer from '../homepage/components/Footer';
import {
    Cancel, Window as WindowsIcon,
    Android as AndroidIcon,
    Apple as MacIcon,
    Terminal as LinuxIcon,
} from '@mui/icons-material';
import { API_BY_COUNTRY } from '../../hooks/commanFunc';
import { updateApiBaseUrl } from '../../hooks/apiHandler';




export const HomePage = (props) => {
    const url = window.location.href;
    console.log("Current URL:", url);
    const [open, setOpen] = useState(false);
    const [region, setRegion] = useState("Canada");

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // --- REGION DETECTION ---
    useEffect(() => {
        let detectedRegion = window.localStorage.getItem("api_region");
        if (detectedRegion) {
            setRegion(detectedRegion);
        } else {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            detectedRegion = timeZone.startsWith("Asia/") ? "India" : "Canada";
            setRegion(detectedRegion);
        }
        const newUrl = API_BY_COUNTRY[detectedRegion] || API_BY_COUNTRY["Canada"];
        console.log(`Detected region: ${detectedRegion}, setting API base URL to: ${newUrl}`);
        updateApiBaseUrl(newUrl, detectedRegion);
    }, []);

    const handlePlatformClick = (platformLabel) => {
        if (platformLabel === 'Windows') {
            // Triggering direct download for Windows installer
            const downloadUrl = url + "/downloads/MiiRAPOS_setup_v1.2.2.exe"; // Path to your installer
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', 'MiiRAPOS_setup_v1.2.2.exe');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else if (platformLabel === 'Android') {
            // Open Google Play Store listing in a new tab
            window.open("https://play.google.com/store/apps/details?id=com.miirapos.miira_pos", "_blank");
        }
        else if (platformLabel === 'iOS') {
            // Open Apple App Store listing in a new tab
            window.open("https://apps.apple.com/ca/app/miira-pos/id6747954842", "_blank");
        }
        else {
            // Default behavior for other platforms (Linux - Lead capture)
            alert(`The ${platformLabel} version is coming soon! Please contact us for early access.`);
            handleOpen();
        }
    };

    return (
        <Box sx={{
            m: 0,
            p: 0,
        }}
            className="landingPage">
            <Navbar></Navbar>
            {/* Hero Section */}
            <Box
                sx={{
                    background: '#fff',
                    // background: 'linear-gradient(to right,rgb(243, 243, 243),rgb(255, 255, 255))',
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    color: '#222',
                    textAlign: 'center',
                    p: 0,
                    pt: '100px',
                    m: 0,
                }}
            >
                <Container id='home' maxWidth="md">
                    <Typography sx={{ fontSize: { xs: '35px', md: '50px' } }} variant="h2" gutterBottom>
                        Smart, Simple, and Powerful POS for Modern Businesses
                    </Typography>
                    <Typography variant="h6" gutterBottom>
                        Manage sales, inventory, and customers — all from one intuitive platform.
                    </Typography>
                    <Grid container spacing={2} sx={{ mb: 10, maxWidth: '900px', mx: 'auto' }}>
                        {[
                            { label: 'Windows', icon: <WindowsIcon /> },
                            { label: 'Android', icon: <AndroidIcon /> },
                            { label: 'MAC OS', icon: <MacIcon /> },
                            { label: 'Linux', icon: <LinuxIcon /> }
                        ].map((platform) => (
                            <Grid item xs={6} sm={3} key={platform.label}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    startIcon={platform.icon}
                                    size="large"
                                    sx={{ mt: 4, mb: 3, color: '#fff', background: 'tomato' }}
                                    onClick={() => handlePlatformClick(platform.label)}
                                >
                                    {platform.label}
                                </Button>
                            </Grid>
                        ))}
                    </Grid>

                    <Box>
                        <img alt="" src={MainImage} className='main_image'></img>
                    </Box>


                </Container>
            </Box>

            {/* Client Section */}


            {/* <Box sx={{
display: 'flex',
alignItems: 'center',
color: '#222',
textAlign: 'center',
p: 0,
py: '25px',
m: 0,
}} >
<Container maxWidth={false} disableGutters >
<ImageSlider></ImageSlider>
</Container>
</Box> */}
            {/* Features Section */}
            <Box id='features' sx={{
                display: 'flex',
                alignItems: 'center',
                color: '#222',
                textAlign: 'center',
                px: { xs: '15px', md: '50px' },
                py: { xs: '25px', md: '50px' },
                m: 0,
            }}>
                <Container maxWidth={false} disableGutters  >
                    <Typography variant="h3" gutterBottom>
                        Features
                    </Typography>
                    <Typography variant="p" gutterBottom>
                        Your Business. Your Rules. One Smart POS to Handle It All.
                    </Typography>

                    <Features></Features>
                    <Button
                        variant="contained"

                        size="large"
                        sx={{ mt: 4, color: '#fff', background: 'tomato' }}
                        onClick={handleOpen}
                    >
                        Qet Quote
                    </Button>

                </Container>
            </Box>

            {/* Cta Section */}
            <Box
                sx={{

                    background: '#1a1b2f',
                    px: { xs: '15px', md: '50px' },
                    py: { xs: '50px', md: '50px' },
                    display: 'flex',
                    alignItems: 'center',
                    color: '#222',
                    textAlign: 'center',
                    m: 0,
                }}
            >
                <Container maxWidth={false}>



                    <Grid sx={{ py: '50px', color: '#fff', textAlign: { xs: 'center', md: 'left' } }} container spacing={{ xs: 2, md: 3 }}>

                        <Grid item xs={12} sm={12} md={6}>
                            <Typography variant="h3" gutterBottom>
                                Built For All Types of Food Business
                            </Typography>
                            <Typography variant="p" color='#fff' gutterBottom>
                                The all-in-one Restaurant Management System for all types of restaurant formats and food outlets
                            </Typography>
                        </Grid>

                        <Grid sx={{ textAlign: 'center' }} item xs={12} sm={12} md={6}>

                            <Button
                                variant="contained"

                                size="large"
                                sx={{ mt: 4, color: '#fff', background: 'tomato' }}
                                onClick={handleOpen}
                            >
                                Call Now
                            </Button>
                        </Grid>



                    </Grid>

                </Container>
            </Box>

            {/* Integration section */}

            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                color: '#222',
                textAlign: 'center',
                px: { xs: '15px', md: '50px' },
                py: { xs: '25px', md: '50px' },
                m: 0
            }}>
                <Container maxWidth={false} disableGutters  >
                    <Grid sx={{ py: '50px', px: '25px', textAlign: { xs: 'center', md: 'left' } }} container spacing={{ xs: 2, md: 3 }}>

                        <Grid item xs={12} md={6} >
                            <Typography variant="h3" gutterBottom>
                                Multiple integrations - single dashboard
                            </Typography>
                            <Typography variant="body1" gutterBottom>Manage third-party integrations and services directly
                                from MiiRA POS </Typography>
                            <br></br>
                            <Button
                                variant="contained"

                                size="large"
                                sx={{ mt: 3, mb: 3, color: '#fff', background: 'tomato' }}
                                onClick={handleOpen}
                            >
                                Know More
                            </Button>
                            <br></br>
                            Integration Logo
                            <Grid sx={{ textAlign: 'left', justifyContent: 'center' }} container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>

                                <Grid item xs={1} sm={2} md={3}>
                                    <Box>
                                        <img alt="" src={"uber-eats"} style={{ width: '100%', maxWidth: 'fit-content' }}></img>
                                    </Box>
                                </Grid>

                                <Grid item xs={1} sm={2} md={3}>
                                    <Box>
                                        <img alt="" src={"online-selft hosted website"} style={{ width: '100%', maxWidth: 'fit-content' }}></img>
                                    </Box>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={6}><Box>
                            <img alt="" src={IntegrationImage} style={{ width: '100%', maxWidth: 'fit-content' }}></img></Box>
                        </Grid>

                    </Grid>

                </Container>
            </Box>

            {/* usage Section */}

            <Box
                sx={{

                    background: 'tomato',
                    px: { xs: '15px', md: '50px' },
                    py: { xs: '50px', md: '100px' },
                    display: 'flex',
                    alignItems: 'center',
                    color: '#222',
                    textAlign: 'center',
                    m: 0,
                }}
            >
                <Container maxWidth={false}>
                    <Typography sx={{ color: '#fff' }} variant="h3" gutterBottom>
                        Built For All Types of Food Business
                    </Typography>
                    <Typography variant="p" color='#fff' gutterBottom>
                        The all-in-one Restaurant Management System for all types of restaurant formats and food outlets
                    </Typography>

                    <Grid sx={{ py: '50px', justifyContent: 'center', textAlign: 'center', color: '#fff' }} container spacing={{ xs: 2, md: 3 }}>

                        <Grid sx={{ textAlign: 'center' }} item xs={4} sm={4} md={2.3}>
                            <img alt="" src={FoodCourt} style={{ width: '100px', maxWidth: 'fit-content' }}></img>
                            <Typography variant='h5'>Food courts & canteens</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={2.3}>
                            <img alt="" src={Cafe} style={{ width: '100px', maxWidth: 'fit-content' }}></img>
                            <Typography variant='h5'>Cafe</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={2.3}>
                            <img alt="" src={Finedine} style={{ width: '100px', maxWidth: 'fit-content' }}></img>
                            <Typography variant='h5'>Fine Dine</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={2.3}>
                            <img alt="" src={Bar} style={{ width: '100px', maxWidth: 'fit-content' }}></img>
                            <Typography variant='h5'>Bars and Brewery</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={2.3}>
                            <img alt="" src={Pizza} style={{ width: '100px', maxWidth: 'fit-content' }}></img>
                            <Typography variant='h5'>Pizzeria</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={2.3}>
                            <img alt="" src={QRS} style={{ width: '100px', maxWidth: 'fit-content' }}></img>
                            <Typography variant='h5'>QRS</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={2.3}>
                            <img alt="" src={Desserts} style={{ width: '100px', maxWidth: 'fit-content' }}></img>
                            <Typography variant='h5'>Desserts</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={2.3}>
                            <img alt="" src={Largechain} style={{ width: '100px', maxWidth: 'fit-content' }}></img>
                            <Typography variant='h5'>Large Chain</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={2.3}>
                            <img alt="" src={Bakery} style={{ width: '100px', maxWidth: 'fit-content' }}></img>
                            <Typography variant='h5'>Bakery</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={2.3}>
                            <img alt="" src={Cloudkitchen} style={{ width: '100px', maxWidth: 'fit-content' }}></img>
                            <Typography variant='h5'>Cloud Kitchen</Typography>
                        </Grid>


                    </Grid>

                </Container>
            </Box>


            {/* Metric  Section */}
            {/* <Box sx={{
                display: 'flex',
                alignItems: 'center',
                color: '#222',
                textAlign: 'center',
                p: 0,
                py: '50px',
                m: 0,
            }}>
                <Container maxWidth={false}   >
                    <Typography variant="h3" gutterBottom>
                        Our Metrics Tell the Story
                    </Typography>
                    <Typography variant="p" gutterBottom>Our metrics component gives you the inside scoop on your success and helps you stay on top of your game in style. </Typography>

                    <Grid sx={{ py: '50px', px: '25px', textAlign: 'left', justifyContent: 'center' }} container spacing={{ xs: 2, md: 3 }} >

                        <Grid item xs={2} sm={3} md={3}>
                            <Box sx={{ borderLeft: '5px solid tomato', pl: '20px' }}>
                                <Typography variant='h3'>
                                    10k+
                                </Typography>
                                <Typography variant='p'>
                                    Website launched
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={2} sm={3} md={3}>
                            <Box sx={{ borderLeft: '5px solid tomato', pl: '20px' }}>
                                <Typography variant='h3'>
                                    10k+
                                </Typography>
                                <Typography variant='p'>
                                    Website launched
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={2} sm={3} md={3}>
                            <Box sx={{ borderLeft: '5px solid tomato', pl: '20px' }}>
                                <Typography variant='h3'>
                                    10k+
                                </Typography>
                                <Typography variant='p'>
                                    Website launched
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={2} sm={3} md={3}>
                            <Box sx={{ borderLeft: '5px solid tomato', pl: '20px' }}>
                                <Typography variant='h3'>
                                    10k+
                                </Typography>
                                <Typography variant='p'>
                                    Website launched
                                </Typography>
                            </Box>
                        </Grid>

                    </Grid>

                </Container>
            </Box> */}
            {/* Call TO Action */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                color: '#222',
                textAlign: 'center',
                p: { xs: '20px', md: '50px' },
                m: 0,
            }}>
                <Container maxWidth={'lg'} sx={{
                    background: 'tomato',
                    p: '10px',
                    pt: '50px',
                    borderRadius: '30px',


                }}   >
                    <Typography variant="h3" gutterBottom>
                        Get Started with $0 Setup Fee — Start Selling Smarter Today!
                    </Typography>
                    <Typography sx={{ color: '#fff' }} variant="p" gutterBottom>No upfront costs, no hassle — just powerful POS tools to grow your business from day one.</Typography>
                    <br></br>
                    <Button
                        variant="contained"

                        size="large"
                        sx={{ my: 4, color: '#fff', background: '#1a1b2f' }}
                        onClick={handleOpen}
                    >
                        Call Now
                    </Button>
                    <img alt='' style={{ maxWidth: 'fit-content', width: '100%' }} src={CtaImage}></img>


                </Container>
            </Box>

            {/* Testimonial section */}
            {/* <Box
                sx={{

                    background: '#F8D57E',
                    px: { xs: '15px', md: '50px' },
                    py: { xs: '50px', md: '100px' },
                    display: 'flex',
                    alignItems: 'center',
                    color: '#222',
                    textAlign: 'center',
                    m: 0,
                }}
            >
                <Container maxWidth="xl">
                    <Typography variant="h3" gutterBottom>
                        Real Stories from Satisfied Customers
                    </Typography>
                    <Typography variant="p" gutterBottom>
                        See how our landing page ui kit is making an impact.
                    </Typography>

                    <Grid sx={{ py: '50px', justifyContent: 'center', textAlign: 'left' }} container spacing={{ xs: 3, md: 3 }} >

                        <Grid item xs={12} sm={6} md={6}>
                            <Card sx={{ backgroundColor: '#ffffff', borderRadius: 6, boxShadow: 3, height: '100%' }}>
                                <CardContent sx={{ px: { xs: '20px', md: '50px' }, py: { xs: '20px', md: '50px' } }}>

                                    <Grid sx={{ justifyContent: 'center' }} container spacing={{ xs: 2, md: 3 }} >

                                        <Grid sx={{ textAlign: 'center' }} item xs={12} sm={6} md={4}>
                                            <img style={{ borderRadius: '100px', width: '150px' }} src={""}></img>

                                            <Typography variant="h6" gutterBottom>
                                                Lauren M.
                                            </Typography>
                                            <Typography>
                                                UI Designer@Boo
                                            </Typography>
                                        </Grid>
                                        <Grid sx={{ textAlign: { xs: 'center', md: 'left' } }} item xs={12} sm={6} md={8} >
                                            <img alt="" src={""}></img>
                                            <Box sx={{ p: '8px' }}></Box>
                                            <Typography variant="p" gutterBottom>
                                                "Anima’s Landing Page UI Kit has become a staple in my design toolkit. This kit has everything I need to get the job done quickly and efficiently."
                                            </Typography>
                                        </Grid>
                                    </Grid>


                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6}>
                            <Card sx={{ backgroundColor: '#ffffff', borderRadius: 6, boxShadow: 3, height: '100%' }}>
                                <CardContent sx={{ px: { xs: '20px', md: '50px' }, py: { xs: '20px', md: '50px' } }}>

                                    <Grid sx={{ justifyContent: 'center', textAlign: { xs: 'center', md: 'left' } }} container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>

                                        <Grid sx={{ textAlign: 'center' }} item xs={12} sm={6} md={4}>
                                            <img style={{ borderRadius: '100px', width: '150px' }} src={""}></img>

                                            <Typography variant="h6" gutterBottom>
                                                Lauren M.
                                            </Typography>
                                            <Typography>
                                                UI Designer@Boo
                                            </Typography>
                                        </Grid>
                                        <Grid sx={{ textAlign: { xs: 'center', md: 'left' } }} item xs={12} sm={6} md={8}>

                                            <img alt="" src={""}></img>

                                            <Box sx={{ p: '8px' }}></Box>

                                            <Typography sx={{ marginTop: '20px' }} variant="p" gutterBottom>
                                                "Anima’s Landing Page UI Kit has become a staple in my design toolkit. This kit has everything I need to get the job done quickly and efficiently."
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                </Container>
            </Box> */}
            {/* Contact Us Section */}
            <Box id='contact' sx={{
                display: 'flex',
                alignItems: 'center',
                color: '#222',
                textAlign: 'left',
                p: { xs: '15px', md: '50px' },
                m: 0,
            }}>
                <Container maxWidth={'xl'} sx={{
                    background: '#fff',
                    p: { xs: '25px !important', md: '50px !important' },
                    borderRadius: '30px',
                    boxShadow: 3,
                    height: '100%'


                }}   >
                    <Typography variant="h3" gutterBottom>
                        Get in Touch with Our Team
                    </Typography>
                    <Typography variant="p" gutterBottom>Contact us today and see how simple point-of-sale can be. </Typography>
                    <br></br>
                    <Grid sx={{ justifyContent: 'center' }} container spacing={{ xs: 2, md: 3 }}>

                        <Grid sx={{ textAlign: 'center' }} item xs={12} sm={6} md={6} >
                            <Box>
                                <ul className='info_list'>
                                    {/* <li >
                                        <a className='links2'><PhoneIcon></PhoneIcon> <Typography variant='p'> +012 345 6789</Typography></a>
                                    </li> */}
                                    <li>
                                        <a className='links2' href='mailto:support@miirapos.com'><MailIcon></MailIcon> <Typography variant='p'> support@miirapos.com </Typography></a>

                                    </li>
                                </ul>
                            </Box>
                            {/* <Box sx={{ pt: '50px' }}>
                                <Typography textAlign={'left'} variant="h4" gutterBottom>
                                    Connect with us
                                </Typography>
                                <Box sx={{ textAlign: 'left' }}>
                                    <ul className='socialmedia'>
                                        <li>
                                            <a className='links2'><FacebookIcon></FacebookIcon></a>
                                        </li>
                                        <li>
                                            <a className='links2'><InstagramIcon></InstagramIcon></a>
                                        </li>
                                        <li>
                                            <a className='links2'><XIcon></XIcon></a>
                                        </li>
                                        <li>
                                            <a className='links2'><GoogleIcon></GoogleIcon></a>
                                        </li>

                                    </ul>
                                </Box>
                            </Box> */}
                        </Grid>


                        <Grid sx={{ textAlign: { xs: 'center', md: 'left' } }} item xs={12} sm={6} md={6}>
                            <ContactForm></ContactForm>
                        </Grid>
                    </Grid>
                </Container>
            </Box>


            <Footer></Footer>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}><Typography variant='h5'>Contact Form</Typography> <Cancel onClick={handleClose}></Cancel> </DialogTitle>
                <DialogContent>
                    <ContactForm onClose={handleClose} ></ContactForm>
                </DialogContent>

            </Dialog>

        </Box >
    );
};
